import { useState } from 'react';
import { Checkbox, Flex, Heading, Label, Modal, Paragraph } from '@cof/plastic-components';
import { useFormContext } from 'react-hook-form';
import ExperimentLockGraphicBlack from './ExperimentLockGraphicBlack';
import ModalLink from '../../../ModalLink/index';
import { SingleFormWrapper } from '../../../../pages/QuickCheck/Components/SharedStyledComponents';
import HowDoesItWork from './HowDoesItWork';

const OptInCheckbox = () => {
    const { register } = useFormContext();

    return (
        <Checkbox
            // @ts-expect-error TS2783: 'name' is specified more than once, so this usage will be overwritten.
            name="openBankingOptedIn"
            {...register('openBankingOptedIn')}
            defaultChecked={false}
        />
    );
};

const ObOptInJourney1 = () => {
    const [isHowDoesItWorkModalOpen, setIsHowDoesItWorkModalOpen] = useState(false);

    return (
        <SingleFormWrapper data-qa-id="ob-accept-region-opt-in-card" data-qm-allow>
            <Flex justifyContent="center" mb="md">
                <ExperimentLockGraphicBlack data-qm-allow />
            </Flex>
            {/* @ts-expect-error TS2322: Type '"500"' is not assignable to type 'ResponsiveValue<keyof FontWeightKeys, DefaultTheme> | undefi */}
            <Heading level="4" textAlign="left" fontWeight="500" pb="sm" data-qm-allow>
                Share your banking history to help us make a decision?
            </Heading>
            <Paragraph pb={0} size="small" data-qm-allow>
                You can choose which bank accounts you link to on the next step. It&apos;s quick, easy, and we&apos;d
                never share your data.{' '}
                {/* @ts-expect-error TS2322: Type ' children: string; modalName: string; onClick: () => void; size: string; "data-qa-id": string; */}
                <ModalLink
                    modalName="OB Accept Region How Does It Work"
                    onClick={() => setIsHowDoesItWorkModalOpen(true)}
                    size="small"
                    data-qa-id="ob-accept-region-how-does-it-work-link"
                    aria-label="Sharing your banking history to help us make a decision. How does this work."
                    data-qm-allow
                >
                    How does it work?
                </ModalLink>
            </Paragraph>
            <Label mt={0}>
                <Flex alignItems="flex-start" gap="xs" pt="md">
                    <OptInCheckbox />
                    <Paragraph pb={0} aria-label="Tick to link my bank account on the next step" data-qm-allow>
                        Link my bank account on the next step
                    </Paragraph>
                </Flex>
            </Label>
            <Modal
                id="ob-accept-region-how-does-it-work-modal"
                // @ts-expect-error TS2322: Type 'Element' is not assignable to type 'string'.
                heading={
                    <Heading level="3" textAlign="left" data-qm-allow>
                        How does it work?
                    </Heading>
                }
                rootId="root"
                aria-modal="true"
                data-qa-id="ob-accept-region-how-does-it-work-modal"
                onClose={() => setIsHowDoesItWorkModalOpen(false)}
                isOpen={isHowDoesItWorkModalOpen}
                modalWrapperProps={{
                    // @ts-expect-error TS2353: Object literal may only specify known properties, and 'marginLeft' does not exist in type 'WidthProp
                    marginLeft: '0.8rem',
                    marginRight: '0.8rem'
                }}
            >
                <HowDoesItWork />
            </Modal>
        </SingleFormWrapper>
    );
};

export default ObOptInJourney1;
